import OnScreen from 'onscreen';

( function ( $ ) {
	const wrapper = $( '.content-wrapper.title-decoration' );

	const titleToDecorate = $( '.content-wrapper.title-decoration h2:not(.not-decorated), .woocommerce .entry-content h2:not(.not-decorated), .cmplz-title' );
	titleToDecorate.wrap( "<div class='title-decoration-wrapper'></div>" );

	if ( wrapper.length ) {
		const os = new OnScreen( {
			tolerance: 0,
			container: '.content-wrapper.title-decoration',
		} );

		os.on( 'enter', 'h2', ( element ) => {
			$( element ).addClass( 'decorated' );
		} );
	}
} )( jQuery );
